import { render } from "./TableBarElement.vue?vue&type=template&id=3d33c4aa&scoped=true"
import script from "./TableBarElement.vue?vue&type=script&lang=js"
export * from "./TableBarElement.vue?vue&type=script&lang=js"

import "./TableBarElement.vue?vue&type=style&index=0&id=3d33c4aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d33c4aa"]])

export default __exports__